import { render, staticRenderFns } from "./air-ele.vue?vue&type=template&id=679b9b7b&scoped=true&"
import script from "./air-ele.vue?vue&type=script&lang=js&"
export * from "./air-ele.vue?vue&type=script&lang=js&"
import style0 from "./air-ele.vue?vue&type=style&index=0&id=679b9b7b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "679b9b7b",
  null
  
)

export default component.exports